import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useGameDispatch } from '../../store/global-context';
import { useDungeonCrawlerStore } from '../../store/zustand/useDungeonCrawlerStore';
import styles from './styles.module.scss';
import { GUIActions } from '../../types/game-types';
import { SmallButton } from '../components/SmallButton';
import { Icon } from '../Icon';
import { HelperTooltip } from '../components/HelperTooltip';
import tooltipStyles from '../components/TooltipContents/styles.module.scss';
import { AudioManager } from '@game-libs/audio-manager';
import { MenuEvents } from '@game-libs/models';

export const DungeonKeysButton = memo(function DungeonKeysButton() {
  const { t } = useTranslation('dungeon');
  const dungeonCrawler = useDungeonCrawlerStore((state) => state);
  const dispatch = useGameDispatch();
  const { playSFXNow } = AudioManager();

  if (dungeonCrawler.currentLevel === 0) {
    return null;
  }

  const { keys, remainingCooldown } = dungeonCrawler;
  const canOpen = keys > 0 && remainingCooldown <= 0;

  const handleClick = () => {
    if (!canOpen) return;
    playSFXNow(MenuEvents.CHANGE_VALUE);
    dispatch({ type: GUIActions.OPEN_DUNGEON_CRAWLER });
  };

  const tooltipContent =
    remainingCooldown > 0
      ? t('cooldownMessage', { seconds: remainingCooldown })
      : t('tooltipDescription');

  return (
    <div className={styles.dungeonKeysButton}>
      <HelperTooltip
        content={<div className={tooltipStyles.tooltipDescription}>{tooltipContent}</div>}
        contentClassName={tooltipStyles.tooltipContent}
      >
        <div className={styles.keyButton} data-testid="dungeon-keys-button">
          <SmallButton shadow disabled={!canOpen} onClick={handleClick}>
            <div className={styles.keyButtonInner}>
              <Icon iconId="gray_key" large hasBackground={false} />
              <span className={styles.keyCount}>{keys}</span>
              {/* {remainingCooldown > 0 && (
                <span className={styles.cooldown} title={t('cooldownShort', { seconds: remainingCooldown })}>
                  {t('cooldownShort', { seconds: remainingCooldown })}
                </span>
              )} */}
            </div>
          </SmallButton>
        </div>
      </HelperTooltip>
    </div>
  );
});
